import { createFileRoute } from '@tanstack/react-router'
import { CrosspostingPostsOverview } from '~/features/crossposting/components/crossposting-posts-overview'

export const Route = createFileRoute('/dashboard/crossposting/$listingId/overview')({
  component: OverviewRoute,
})

function OverviewRoute() {
  const { listingId } = Route.useParams()
  return <CrosspostingPostsOverview listingId={listingId} />
}
